/**
 * PalPendant Settings — Domain API Module
 *
 * Wraps the shared V2 API client for all data operations on the
 * PalPendantSettingsPage (display profile CRUD).
 *
 * Stored procedures:
 *   getppendantdspprofiles — read display profiles with nested modes
 *
 * Tables:
 *   att_palpendant_data_type — data type definitions (Custom Text, Resident Name, etc.)
 *
 * Transaction types:
 *   palpendant_profile_add    — add display profile (creates profile + 3 mode records)
 *   palpendant_profile_edit   — edit display profile (updates profile + modes)
 *   palpendant_profile_delete — delete display profile(s)
 */

import { apiFetch, apiTransaction } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// READ operations
// ---------------------------------------------------------------------------

/** Fetch all PalPendant display profiles (with nested modes) for a campus. */
export function fetchProfiles(campusId) {
    return apiFetch({
        procedure: 'getppendantdspprofiles',
        reqType: 'stored',
        payload: { campus_id: campusId },
    });
}

/** Fetch pendant data type definitions (Custom Text, Resident Name, Area/Room, Staff Name). */
export function fetchDataTypes() {
    return apiFetch({
        table: 'att_palpendant_data_type',
        procedure: 'fetchall',
        reqType: 'direct',
    });
}

// ---------------------------------------------------------------------------
// WRITE operations
// ---------------------------------------------------------------------------

/**
 * Add a new display profile.
 * Backend creates the profile record + 3 mode records (Idle, Panic, Accepted).
 */
export function addProfile(payload, { campusId, userId, clientId }) {
    return apiTransaction({
        transType: 'palpendant_profile_add',
        payload,
        campusId,
        userId,
        clientId,
    });
}

/**
 * Edit an existing display profile (profile name + mode configs).
 * Requires oldPayload for audit trail.
 */
export function editProfile(payload, oldPayload, { campusId, userId, clientId }) {
    return apiTransaction({
        transType: 'palpendant_profile_edit',
        payload,
        oldPayload,
        campusId,
        userId,
        clientId,
    });
}

/**
 * Delete one or more display profiles.
 */
export function deleteProfiles(payload, { campusId, userId, clientId }) {
    return apiTransaction({
        transType: 'palpendant_profile_delete',
        payload,
        campusId,
        userId,
        clientId,
    });
}
